import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// styles used by the others components.
import {
  QuestionLabel,
  Container,
  Content,
  TextArea,
} from '../styles';

// styles local.
import {
  Checkbox,
} from './styles';

const SingleQuestionType = (props) => {
  const {
    questionOptions,
    label,
    index,
    optionAnswers,
    otherDescription,
  } = props;

  return (
    <Container>
      <QuestionLabel>{`Question ${index + 1}: ${label} (Single Selection)`}</QuestionLabel>
      {
        _.chain(questionOptions)
          .sortBy('order')
          .map(({ id, label: labelOption, optionType }) => (
            <Content>
              <Checkbox
                radio
                key={id}
                label={labelOption}
                checked={!_.isEmpty(optionAnswers) && optionAnswers.find((optionAnswer) => optionAnswer === id)}
                disabled
              />
              {(optionType === 'other') && (
                <TextArea
                  value={otherDescription}
                  disabled
                />
              )}
            </Content>
          ))
          .value()
      }
    </Container>
  );
};

SingleQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  questionOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string,
  })).isRequired,
  selectedValue: PropTypes.shape({}),
  index: PropTypes.number,
  optionAnswers: PropTypes.instanceOf(Array),
  otherDescription: PropTypes.string,
};

SingleQuestionType.defaultProps = {
  selectedValue: {},
  index: null,
  optionAnswers: [],
  otherDescription: '',
};

export default SingleQuestionType;
